import { selectIsMixedListing } from './selectIsMixedListing';
import { selectIsNewbuildingListing } from './selectIsNewbuildingListing';
import { IAppState } from '../../common/state';

/**
 * Определяет, новостроечная или смешанная выдача.
 */
export function selectIsNewbuildingOrMixedListing(state: IAppState): boolean {
  const isAvailableInNewbuildingList = selectIsNewbuildingListing(state);
  const isAvailableInMixedList = selectIsMixedListing(state);

  return isAvailableInNewbuildingList || isAvailableInMixedList;
}
